export class DateValidator {
    constructor(message) {
        this.message = message;
    }
    validate(date) {
        const day = +date.day;
        const month = +date.month;
        const year = +date.year;
        if (day > 0 && month > 0 && year > 0) {
            const parsedDate = new Date(year, month - 1, day);
            return parsedDate && !isNaN(parsedDate.getTime()) && parsedDate.getDate() === day;
        }
        return false;
    }
}
//# sourceMappingURL=DateValidator.js.map